<template>
  <lazy-list-display-y
    :nb="nb_lines"
    :block_rounding="1024 / 16"
    @fetch_data="fetch_data"
  >
    <template #default="{nby, height}">
      <hex-viewer-line
        :key="nby"
        v-bind="arguments_for_nb(nby)"
        :style="height"
      ></hex-viewer-line>
    </template>
  </lazy-list-display-y>
</template>

<script>
import _ from 'lodash'

import Vue from 'vue'
import { mapGetters } from 'vuex'

import { get_file_size, get_file_data } from '@/api/subscriptions.js'
import { lazy_scroll_requester_base } from '@/components/lazy_list_requester.js'

import { subscription_mixin } from '@/components/mixin.js'
import LazyListDisplayY from '@/components/lazy_list_display_y.vue'
import HexViewerLine from '@/components/hex_viewer_line.vue'

// *****************************************************************************

class lazy_scroll_hexviewer_requester extends lazy_scroll_requester_base {
  initialize(available_items, block_size, project_id, rawfile_uid) {
    super.initialize(available_items, block_size)
    this.project_id = project_id
    this.rawfile_uid = rawfile_uid
  }

  async request_blocks(keys) {
    const requested_keys = _.map(keys, function(x) {
      return parseInt(x, 10)
    })
    const raw_data = new Uint8Array(
      await get_file_data(this.project_id, this.rawfile_uid, requested_keys)
    )
    let block_size = raw_data.length / keys.length
    let res = {}
    for (const [index, slot] of keys.entries()) {
      const slot_start = index * block_size
      const slot_stop = slot_start + block_size
      let slot_data = raw_data.slice(slot_start, slot_stop)
      res[slot] = slot_data
    }
    return res
  }
}

// *****************************************************************************

const nb_bytes_per_line = 16
const nb_bytes_per_block = 1024

export default {
  name: 'LazyHexviewer',
  components: {
    LazyListDisplayY,
    HexViewerLine,
  },
  mixins: [subscription_mixin],
  props: ['project_id', 'rawfile_uid'],
  data() {
    return {
      file_size: undefined,
      file_data: {},
    }
  },
  computed: {
    nb_lines() {
      return Math.floor(
        (this.file_size + nb_bytes_per_line - 1) / nb_bytes_per_line
      )
    },
  },
  watch: {
    rawfile_uid: {
      immediate: true,
      async handler(nv) {
        let res = 0
        if (!_.isUndefined(nv)) {
          res = await get_file_size(this.project_id, nv)
        }
        this.file_size = res
        this.$options.my_data_requester.reset()
      },
    },
  },

  beforeCreate() {
    this.$options.my_data_requester = new lazy_scroll_hexviewer_requester()
  },

  beforeMount() {
    this.$options.my_data_requester.initialize(
      this.file_data,
      nb_bytes_per_block / nb_bytes_per_line,
      this.project_id,
      this.rawfile_uid
    )
  },

  methods: {
    fetch_data(start, stop) {
      this.$options.my_data_requester.update(start, stop)
    },
    arguments_for_nb(nb) {
      const bytes_per_slot = nb_bytes_per_block
      let start = nb * nb_bytes_per_line
      let stop = start + nb_bytes_per_line
      let slot_number = Math.floor(start / bytes_per_slot)
      let relative_start = start % bytes_per_slot
      let relative_stop = relative_start + nb_bytes_per_line
      let bytes = this.file_data[slot_number]
      if (bytes) {
        bytes = bytes.slice(relative_start, relative_stop)
      }
      let unknown = false
      if (!_.isUndefined(this.nb_lines)) {
        unknown = _.isUndefined(bytes) && nb < this.nb_lines
      }
      return {
        bytes,
        start,
        stop,
        unknown,
      }
    },
  },
}
</script>
